// extracted by mini-css-extract-plugin
export var container = "_dn-0";
export var infoIcon = "_dn-2";
export var internalLabel = "_dn-3";
export var titleRowCol = "_dn-1";